const NAME = "MY_PEOPLE_SCHEDULE";

export default NAME;
